import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { resolvePublicSeo } from "./publicSeo";

export default function RouteSeo({ blogs = [], blogsLoading = false, blogsError = false }) {
  const { pathname } = useLocation();
  const seo = resolvePublicSeo(pathname, { blogs, blogsLoading, blogsError });

  // Private applications retain their own titles and authentication. Marketing
  // canonicals, descriptions and social previews must not leak into them.
  if (seo.status === "private") {
    const title = /^\/hrm(?:\/|$)/i.test(pathname) ? "HRM | Antrazal" : "Workspace | Antrazal";
    return <Helmet defer={false}><title>{title}</title><meta name="robots" content="noindex, nofollow" /></Helmet>;
  }

  return (
    <Helmet defer={false}>
      <title>{seo.title}</title>
      {seo.description && <meta name="description" content={seo.description} />}
      {seo.robots && <meta name="robots" content={seo.robots} />}
      {seo.canonical && <link rel="canonical" href={seo.canonical} />}
      {seo.status === "public" && <meta property="og:site_name" content="Antrazal" />}
      {seo.type && <meta property="og:type" content={seo.type} />}
      {seo.canonical && <meta property="og:url" content={seo.canonical} />}
      {seo.status === "public" && <meta property="og:title" content={seo.title} />}
      {seo.description && <meta property="og:description" content={seo.description} />}
      {seo.image && <meta property="og:image" content={seo.image} />}
      {seo.status === "public" && <meta name="twitter:card" content={seo.image ? "summary_large_image" : "summary"} />}
      {seo.status === "public" && <meta name="twitter:title" content={seo.title} />}
      {seo.description && <meta name="twitter:description" content={seo.description} />}
      {seo.image && <meta name="twitter:image" content={seo.image} />}
      {seo.schema && <script type="application/ld+json">{JSON.stringify(seo.schema).replace(/</g, '\\u003c')}</script>}
    </Helmet>
  );
}
